import { ADMIN_NAV } from "../../config/nav";
import { useAuth } from "../../context/AuthContext";
import PortalLayout from "./PortalLayout";

export default function AdminLayout() {
  const { user } = useAuth();
  const items = ADMIN_NAV.filter((i) => !user?.role || i.roles.includes(user.role));
  return <PortalLayout navItems={items} portalName="Admin Portal" />;
}
